<template>
  <v-dialog v-model="dialog" max-width="60%" persistent>
    <v-card class="mx-auto">
      <v-card-title>
        Message Student
        <v-spacer />
        <v-btn
          class="text-capitalize"
          color="deep-orange darken-1"
          text
          @click="dialog = !dialog"
        >
          close
          <v-icon class="mx-2">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="messageForm">
          <div>
            <v-textarea
              v-model="message"
              clearable
              append-icon="forum"
              outlined
              placeholder="Message ....."
              label="Enter Message"
            />
          </div>
          <div class="d-flex justify-space-between my-3">
            <v-btn class="primary" @click="sendMessage('sms')">
              Send Sms
              <v-icon class="mx-2">send</v-icon>
            </v-btn>
            <v-btn class="primary" @click="sendMessage('email')">
              Send Email
              <v-icon class="mx-2">forward_to_inbox</v-icon>
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: { user: Array, messageDialog: Boolean },
  name: "MessageStudentDialog",
  data: function () {
    return {
      message: "",
    };
  },
  computed: {
    dialog: {
      get() {
        return this.messageDialog;
      },
      set(val) {
        this.$emit("setMessageDialog", val);
      },
    },
  },
  methods: {
    sendMessage(type) {
      const data = {
        type,
        phoneNo: this.user.profile.phoneNo,
        email: this.user.email,
        message: this.message,
        name: this.user.name,
      };
      this.$store.dispatch("Administrator/notify", data);
      this.$refs.messageForm.reset();
      this.dialog = !this.dialog;
    },
  },
};
</script>
